<div class="report-container">

    <div id="reportFilter" class="filter-container">
        <div class="dx-fieldset">
            <div class="dx-field">
                <!-- Promotion field -->
                @if (name != 'Buy in the Green' && name != 'Core Range' && name != 'Rebate & Focus Export') {
                    <div class="dx-field-container">
                        <div class="dx-field-label report_label">Promotion:</div>
                        <div class="dx-field-value">
                            <dx-select-box id="promotionNames"  displayExpr="promotion_name" valueExpr="promotion_period_id" [dataSource]="promotionNames" (onValueChanged)="storePromotionName($event)" width="auto">
                                <dx-validator [validationGroup]="validationGroup">
                                    <dxi-validation-rule
                                      type="required"
                                      message=" "

                                    ></dxi-validation-rule>

                                  </dx-validator></dx-select-box>
                        </div>
                    </div>
                }
                <!-- Promotion field -->
                @if (name == 'Buy in the Green') {
                    <div class="dx-field-container">
                        <div class="dx-field-label report_label">Start Date:</div>
                        <div class="dx-field-value">
                            <!-- Use dxDateBox for date selection -->
                            <dx-date-box (onValueChanged)="storeBuyInGreenDate($event)"
                                (value)="selectedDate"
                                pickerType="calendar"
                                displayFormat="dd-MM-yyyy"
                                placeholder="Select a date"
                                [showClearButton]="true"
                                width="auto"
                                type="date" >
                                <dx-validator [validationGroup]="validationGroup">
                                    <dxi-validation-rule
                                      type="required"
                                      message=" "
                                    ></dxi-validation-rule>

                                  </dx-validator>
                            </dx-date-box>
                        </div>

                    </div>
                    <div class="dx-field-container">
                        <div class="dx-field-label report_label">Weeks:</div>
                        <div class="dx-field-value">
                            <!-- Use dxDateBox for date selection -->
                            <dx-number-box (onValueChanged)="storeBuyInGreenWeeksSelected($event)"
                            [value]="4"
                            [min]="4"
                            [max]="8"
                            [showSpinButtons]="true"
                            [inputAttr]="{ 'aria-label': 'Min And Max' }"
                            ></dx-number-box>
                        </div>
                    </div>
                }
                <!-- Filter by field -->
                <div class="dx-field-container">
                    <div class="dx-field-label report_label">Group:</div>
                    <div class="dx-field-value">
                        <dx-select-box id="promotionFilter" displayExpr="buying_group_name" valueExpr="id" [dataSource]="buyingGroups" (onValueChanged)="storeGroupData($event)" width="auto">
                            <dx-validator [validationGroup]="validationGroup">
                                <dxi-validation-rule
                                  type="required"
                                  message=" "
                                ></dxi-validation-rule>

                              </dx-validator></dx-select-box>
                    </div>
                </div>
                @if (name == 'Core Range' || name == 'Rebate & Focus Export') {
                    <div class="dx-field-container">
                        <div class="dx-field-label report_label">Core Range:</div>
                        <div class="dx-field-value">
                            <dx-select-box id="coreRangeFilter"
                                           [searchEnabled]="true"
                                           placeholder="Select a range..."
                                           [searchExpr]="['id', 'range_name']"
                                           searchMode="contains"
                                           displayExpr="range_name"
                                           [dataSource]="coreRangeHeaders"
                                           (onValueChanged)="storeCoreRangeData($event)"
                                           width="auto"
                                           [(value)]="selectedRange">
                            </dx-select-box>
                        </div>
                    </div>
                }
                <!-- Filter by field -->
                @if (name == 'Promotion Confirmation') {
                    <div class="dx-field-container">
                        <div class="dx-field-label report_label">Supplier:</div>
                        <div class="dx-field-value">
                            <dx-select-box id="promotionFilter"
                                            [searchEnabled]="true"
                                            placeholder="select..."
                                            [searchExpr]="['supplier_code', 'supplier_name']"
                                            searchMode="contains"
                                            displayExpr="supplier_name"
                                            valueExpr="supplier_code"
                                            [dataSource]="suppliersView"
                                            (onOpened)="getSuppliers()"
                                            (onValueChanged)="storeSupplierFilterData($event)"
                                            width="auto">

                                <dx-validator [validationGroup]="validationGroup">
                                    <dxi-validation-rule
                                      type="required"
                                      message=" "
                                    ></dxi-validation-rule>

                                  </dx-validator></dx-select-box>


                        </div>
                    </div>
                }
            </div>
        </div>

        @if (name !== 'Promotion Details Export' && name !== 'Rebate & Focus Export') {
            <div class="dropdown">

                <div class="disclaimer-title" (click)="toggleDropdown()"><p> Set disclaimer </p>
                <span>{{ isOpen ? '&#9207;' : '&#9205;' }}</span></div>

              <div class="dropdown-content" [style.display]="isOpen ? 'block' : 'none'">
                <div> <dx-text-area [(value)]="disclaimer" [valueChangeEvent]="'keyup'" [maxLength]="maxLength"></dx-text-area></div>
                <dx-button type="default" (click)="submitDisclaimer()" height="25px" width="100px"><p>Set Disclaimer</p></dx-button>

                <span>{{disclaimer.length}}/{{maxLength}}</span>
              </div>
            </div>
        }
        <div class="options-filter">
            @if (name == 'Promotion Confirmation') {
                <div class="check-box"> <dx-check-box text="Exclude Price" (onValueChanged)="onPriceExclude($event)"></dx-check-box></div>
            }
            @if (isWarehouseAdvice() || name == 'Pos & Press Brief Report' || (name == 'Promotion Confirmation' && showExportToExcel)) {
                <div class="check-box"> <dx-check-box text="Export to Spreadsheet" (onValueChanged)="onValueChanged($event)"></dx-check-box></div>
            }
            @if (isWarehouseAdvice()) {
                <div class="check-box" style="margin: 0 15px;"> <dx-check-box text="Exclude EDLP" [(value)]="excludeEDLP" (onValueChanged)="onExcludeEDLPChange($event)"></dx-check-box></div>
            }
            @if (name == 'Core Range') {
                <div class="check-box"> <dx-check-box text="Rebate" (onValueChanged)="onRebateCheck($event)"></dx-check-box></div>
            }
            @if (name != 'Promotion Confirmation' && name != 'Core Range' && !isWarehouseAdvice() && name != 'Rebate & Focus Export') {
                <div class="check-box"></div>
            }

            <div class="button-wrapper">

                @if (!loading) {
                    <dx-button class="dx-widget dx-button dx-button-mode-contained dx-button-default dx-button-has-text" style="width: 150px;" printSectionId="report" [useSubmitBehavior]="true" [validationGroup]="validationGroup" (onClick)="validateAndSubmit()">
                        <div class="dx-button-content">
                            @if (name == 'Promotion Details Export' || name == 'Media Plan Export') {
                                <div class="dx-button-text">Export<i class="dx-icon-export"></i></div>
                            } @else {
                                <div class="dx-button-text">Download<i class="dx-icon-download"></i></div>
                            }
                        </div>
                    </dx-button>
                } @else {
                    <dx-button class="dx-widget dx-button dx-button-mode-contained dx-button-default dx-button-has-text loading-button" [disabled]="true" style="width: 150px;" printSectionId="report">
                        <div class="dx-button-content">
                            <div class="lds-dual-ring"></div>
                        </div>
                    </dx-button>
                }

            </div>
        </div>

    </div>
    <dx-validation-summary validationGroup="reportForm"></dx-validation-summary>

  </div>
